// extracted by mini-css-extract-plugin
export default {"business_card":"BusinessChoosePlaceCap_business_card__MyGbx","icon_wrapper":"BusinessChoosePlaceCap_icon_wrapper__-zHeo","cap_text":"BusinessChoosePlaceCap_cap_text__zi1y3"};